import { BASE_API_URL, CONTENTDB_S3_URL, WEBDB_S3_URL } from '../envs.js';
import { isContentDbEnabled } from '../urlHandling/urlSearchParams.js';
export async function fetchB2BHierarchy(lang) {
    const dbUrl = isContentDbEnabled ? CONTENTDB_S3_URL : WEBDB_S3_URL;
    const propagatedParams = typeof document !== 'undefined' ? document.location.search : '';
    const mergedUrl = `${dbUrl}/b2b_merged/${lang}/b2b_sp_hierarchy.json${propagatedParams}`;
    return fetch(mergedUrl)
        .then((r) => (r.ok ? r.json() : null))
        .then((r) => {
        return r;
    });
}
export async function b2bSearch(qtext, lang) {
    return fetch(`${BASE_API_URL}/api/6/b2b_search?qtext=${qtext}&lang=${lang}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((r) => {
        return r;
    });
}
//# sourceMappingURL=api-b2b.js.map